export const cloudflareCountryCode = window.__COUNTRY_CODE__ ? window.__COUNTRY_CODE__ : ''
export const MEDIA_OPTS_STORAGE_KEY = 'lc-media-opts'

export const supportedBrowsers = {
  'Chrome': 52,
  'Firefox': 52,
  'Opera': 46,
  'chrome': 52,
  'firefox': 52,
  'opera': 46
}

export const workingBrowsers = {
  'Safari': 11,
  'safari': 11
}

const apiRoot2 = 'https://vcapi2.learncube.com'
// const agoraRecordingUrl = 'https://api.agora.io/v1/apps/23fdd085e839411aaf9054aa2849cee6/cloud_recording'

const apiEnvironments = {
  'local': 'local-test',
  'dev': 'dev-test',
  'beta': 'pre-deploy',
  'staging': 'pre-deploy',
  'predeploy': 'pre-deploy',
  'production': 'prod',
  'api': 'prod',
  'apisanity': 'prod'
}

export const logUrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/log`

export const vuexStateUrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/state`
export const vuexStateActionsUrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/actions`
export const clockUrl = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/clock/`
export const vuexS3UrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/save-state`
export const twilioTokenUrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/twilio/room/token`
export const reportingUrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/reporting`

// Agora Recording
export const agoraTokenUrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/agora/room/token`
export const contentLibraryBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/library`
export const agoraRecordingUrlBase = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/agora/recording`
export const agoraRecordingStreamUrl = `${apiRoot2}/${apiEnvironments[process.env.VUE_APP_LC_ENV || 'local']}/agora/recording/stream-url/`

export const lcContentLibBase = `${apiRoot2}/${apiEnvironments[process.env.LC_ENV || 'local']}/library`

const lcEnvironments = {
  'local': 'http://localhost:8000',
  'dev': 'https://eu-dev.learn-cube.com',
  'beta': 'http://qa.learn-cube.com',
  'staging': 'https://qa.learn-cube.com',
  'predeploy': 'https://eu-predeploy.learn-cube.com',
  'production': 'https://app.learncube.com',
  'api': 'https://api.learncube.com',
  'apisanity': 'https://apisanity.learncube.com'
}

// const lcApiPath = lcConf ? '/api' : ''
// const lcApiRoot = lcConf ? lcEnvironments[process.env.VUE_APP_LC_ENV || 'local'] : ''
// export const lcApiBase = `${lcApiRoot}/vc${lcApiPath}`

export function getLcApiBase (isApiClass) {
  const lcApiPath = isApiClass ? '/api' : ''
  const lcApiRoot = isApiClass ? lcEnvironments[process.env.VUE_APP_LC_ENV || 'local'] : ''
  return `${lcApiRoot}/vc${lcApiPath}`
}

const wsEnvironments = {
  'local': 'vcapiws-local',
  'dev': 'vcapiws-dev',
  'predeploy': 'vcapiws-predeploy',
  'production': 'vcapiws',
  'apisanity': 'vcapiws',
  'api': 'vcapiws'
}

export const socketUrl = `wss://${wsEnvironments[process.env.VUE_APP_LC_ENV || 'local']}.learncube.com`

const staticUrls = {
  'production': '//static.learncube.net',
  'predeploy': '//static.learncube.net',
  'api': '//static.learncube.net',
  'apisanity': '//static.learncube.net',
  'local': 'http://localhost:8000/static',
  'dev': '//static.learncube.net'
}

export const staticUrl = staticUrls[process.env.VUE_APP_LC_ENV || 'production']

export const introductionClassTabs = [
  {
    'id': 'tab_af3eaec1-6d30-11ea-9a40-23ac546b2b33',
    'type': 'tab',
    'open': true,
    'name': 'What do I need to teach online?',
    'active': true,
    'content': {
      'title': 'What do I need to teach online?',
      'link': 'https://www.youtube.com/watch?v=928H6zAuBNo',
      'contentType': 'youtube',
      'pageNumber': 1
    },
    'annotations': {},
    'interactions': [],
    'images': [],
    'editable': true,
    'rerender': 0,
    'created': 1584986580828
  },
    {
    'id': 'tab_88be92b1-6d30-11ea-9a40-23ac546b2b33',
    'type': 'tab',
    'open': true,
    'name': 'How to teach using a Virtual Classroom',
    'active': false,
    'content': {
      'title': 'How to teach using a Virtual Classroom',
      'link': 'https://www.youtube.com/watch?v=Jg6gpRGAC-k',
      'contentType': 'youtube',
      'pageNumber': 1
    },
    'annotations': {},
    'interactions': [],
    'images': [],
    'editable': true,
    'rerender': 0,
    'created': 1584986645420
  },
  {
    'id': 'tab_cd7e3680-6d30-11ea-9a40-23ac546b2b33',
    'type': 'tab',
    'open': true,
    'name': 'Classroom Tools',
    'active': false,
    'content': {
      'title': 'Classroom Tools',
      'link': 'https://www.youtube.com/watch?v=0uEPAWcfEY0&t=',
      'contentType': 'youtube',
      'pageNumber': 1
    },
    'annotations': {},
    'interactions': [],
    'images': [],
    'editable': true,
    'rerender': 0,
    'created': 1584986696168
  },
  {
    'id': 'tab_ef6ae7c1-6d30-11ea-9a40-23ac546b2b33',
    'type': 'tab',
    'open': true,
    'name': 'Adding Lesson Materials',
    'active': false,
    'content': {
      'title': 'Adding Lesson Materials',
      'link': 'https://www.youtube.com/watch?v=2OcOOWbERL0',
      'contentType': 'youtube',
      'pageNumber': 1
    },
    'annotations': {},
    'interactions': [],
    'images': [],
    'editable': true,
    'rerender': 0,
    'created': 1584986753084
  },
  {
    'id': 'tab_07727c70-6d31-11ea-9a40-23ac546b2b33',
    'type': 'tab',
    'open': true,
    'name': 'Trouble Shooting',
    'active': false,
    'content': {
      'title': 'Trouble Shooting',
      'link': 'https://www.youtube.com/watch?v=FU3_udUx3WE',
      'contentType': 'youtube',
      'pageNumber': 1
    },
    'annotations': {},
    'interactions': [],
    'images': [],
    'editable': true,
    'rerender': 0,
    'created': 1584986793399
  },
  {
    'id': 'tab_1ef047b1-6d31-11ea-9a40-23ac546b2b33',
    'type': 'tab',
    'open': true,
    'name': 'Advanced Tools',
    'active': false,
    'content': {
      'title': 'Advanced Tools',
      'link': 'https://www.youtube.com/watch?v=l5wOQE17YsE',
      'contentType': 'youtube',
      'pageNumber': 1
    },
    'annotations': {},
    'interactions': [],
    'images': [],
    'editable': true,
    'rerender': 0,
    'created': 1584986832811
  }
]
